module.exports = __webpack_public_path__ + "static/media/059-doctor.07f9363c.svg";